import { Model } from "@singularsystems/neo-core";
import { NeoGrid } from "@singularsystems/neo-react";
import { IGenericApiClient } from "../../../ApiClients/Catalogues/GenericApiClient";
import { CatalogueEntry } from "../CatalogueEntry";
import DataCache from "../../../Services/DataCache";
import * as CatalogueRoles from "../../../Models/Security/CatalogueRoles"
import AssetClass from "../../../Models/Catalogue/Generic/AssetClass";
import { Catalogue } from "@singularsystems/neo-react-services";

export default class AssetClassCatalogueEntry extends CatalogueEntry<AssetClass> {

    constructor() {
        super("Asset Classes", AssetClass);
    }

    public get editRole() {
        return CatalogueRoles.AssetClass.Edit;
    }

    public getCacheEntry(cache: DataCache) {
        return cache.assetClasses;
    }
    
    public getSaveEndpoint(apiClient: IGenericApiClient) {
        return apiClient.saveAssetClasses;
    }
    
    public renderRow(item: AssetClass, meta: Model.TransformMetaType<AssetClass>) {
        return (
            <NeoGrid.Row>
                <NeoGrid.Column bind={meta.assetClassName} />
                <Catalogue.ButtonColumn />
            </NeoGrid.Row>
        )
    }
}